// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  align-items: start;
}

.help-sidebar {
  position: sticky;
  top: 20px;
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 16px;
  max-height: calc(100vh - 40px);
  overflow-y: auto;
}

.help-search {
  width: 100%;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid var(--color-border);
  background-color: var(--color-bg-dark);
  color: var(--color-text-light);
  font-size: 14px;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.help-search:focus {
  outline: none;
  border-color: var(--wylie-pink);
}

.help-toc-category {
  margin-bottom: 18px;
}

.help-toc-category-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--wylie-pink);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.help-toc-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.help-toc-list li {
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  color: var(--color-text-light);
  font-size: 14px;
  line-height: 1.3;
  transition: background-color 0.15s;
}

.help-toc-list li:hover {
  background-color: var(--color-bg-hover);
}

.help-toc-list li.active {
  background-color: var(--wylie-purple);
  color: var(--wylie-white);
}

.help-main {
  min-width: 0;
}

.help-main h1 {
  color: var(--color-text-light);
  margin-bottom: 8px;
}

.help-intro {
  color: var(--color-text-muted);
  margin-bottom: 24px;
  font-size: 14px;
}

.help-empty {
  color: var(--color-text-muted);
  padding: 40px 0;
  text-align: center;
}

.help-section {
  background-color: var(--color-bg-card);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 20px 24px;
  margin-bottom: 16px;
  scroll-margin-top: 20px;
  transition: box-shadow 0.3s, border-color 0.3s;
}

.help-section.highlight {
  border-color: var(--wylie-pink);
  box-shadow: 0 0 0 2px rgba(220, 37, 101, 0.25);
}

.help-section-title {
  color: var(--color-text-light);
  font-size: 1.3rem;
  margin: 0 0 4px 0;
}

.help-section-category {
  display: inline-block;
  font-size: 11px;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
}

.help-section p {
  color: var(--color-text-light);
  line-height: 1.6;
  margin: 8px 0;
}

.help-section ul,
.help-section ol {
  color: var(--color-text-light);
  line-height: 1.6;
  padding-left: 20px;
  margin: 8px 0;
}

.help-section li {
  margin-bottom: 4px;
}

.help-section h3 {
  color: var(--color-text-light);
  font-size: 1.05rem;
  margin: 16px 0 6px 0;
}

.help-tip {
  background-color: rgba(40, 139, 205, 0.12);
  border-left: 3px solid var(--wylie-blue);
  padding: 10px 14px;
  margin: 12px 0;
  border-radius: 4px;
  color: var(--color-text-light);
  font-size: 14px;
  line-height: 1.5;
}

.help-tip::before {
  content: '💡 ';
}

.help-note {
  background-color: rgba(220, 37, 101, 0.12);
  border-left: 3px solid var(--wylie-pink);
  padding: 10px 14px;
  margin: 12px 0;
  border-radius: 4px;
  color: var(--color-text-light);
  font-size: 14px;
  line-height: 1.5;
}

@media (max-width: 900px) {
  .help-layout {
    grid-template-columns: 1fr;
  }

  .help-sidebar {
    position: relative;
    top: 0;
    max-height: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Help.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,sCAAsC;EACtC,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,gBAAgB;EAClB;AACF","sourcesContent":[".help-layout {\n  display: grid;\n  grid-template-columns: 280px 1fr;\n  gap: 32px;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n  align-items: start;\n}\n\n.help-sidebar {\n  position: sticky;\n  top: 20px;\n  background-color: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 16px;\n  max-height: calc(100vh - 40px);\n  overflow-y: auto;\n}\n\n.help-search {\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border);\n  background-color: var(--color-bg-dark);\n  color: var(--color-text-light);\n  font-size: 14px;\n  margin-bottom: 16px;\n  box-sizing: border-box;\n}\n\n.help-search:focus {\n  outline: none;\n  border-color: var(--wylie-pink);\n}\n\n.help-toc-category {\n  margin-bottom: 18px;\n}\n\n.help-toc-category-title {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--wylie-pink);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 6px;\n}\n\n.help-toc-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.help-toc-list li {\n  padding: 6px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  color: var(--color-text-light);\n  font-size: 14px;\n  line-height: 1.3;\n  transition: background-color 0.15s;\n}\n\n.help-toc-list li:hover {\n  background-color: var(--color-bg-hover);\n}\n\n.help-toc-list li.active {\n  background-color: var(--wylie-purple);\n  color: var(--wylie-white);\n}\n\n.help-main {\n  min-width: 0;\n}\n\n.help-main h1 {\n  color: var(--color-text-light);\n  margin-bottom: 8px;\n}\n\n.help-intro {\n  color: var(--color-text-muted);\n  margin-bottom: 24px;\n  font-size: 14px;\n}\n\n.help-empty {\n  color: var(--color-text-muted);\n  padding: 40px 0;\n  text-align: center;\n}\n\n.help-section {\n  background-color: var(--color-bg-card);\n  border: 1px solid var(--color-border);\n  border-radius: 8px;\n  padding: 20px 24px;\n  margin-bottom: 16px;\n  scroll-margin-top: 20px;\n  transition: box-shadow 0.3s, border-color 0.3s;\n}\n\n.help-section.highlight {\n  border-color: var(--wylie-pink);\n  box-shadow: 0 0 0 2px rgba(220, 37, 101, 0.25);\n}\n\n.help-section-title {\n  color: var(--color-text-light);\n  font-size: 1.3rem;\n  margin: 0 0 4px 0;\n}\n\n.help-section-category {\n  display: inline-block;\n  font-size: 11px;\n  color: var(--color-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n}\n\n.help-section p {\n  color: var(--color-text-light);\n  line-height: 1.6;\n  margin: 8px 0;\n}\n\n.help-section ul,\n.help-section ol {\n  color: var(--color-text-light);\n  line-height: 1.6;\n  padding-left: 20px;\n  margin: 8px 0;\n}\n\n.help-section li {\n  margin-bottom: 4px;\n}\n\n.help-section h3 {\n  color: var(--color-text-light);\n  font-size: 1.05rem;\n  margin: 16px 0 6px 0;\n}\n\n.help-tip {\n  background-color: rgba(40, 139, 205, 0.12);\n  border-left: 3px solid var(--wylie-blue);\n  padding: 10px 14px;\n  margin: 12px 0;\n  border-radius: 4px;\n  color: var(--color-text-light);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.help-tip::before {\n  content: '💡 ';\n}\n\n.help-note {\n  background-color: rgba(220, 37, 101, 0.12);\n  border-left: 3px solid var(--wylie-pink);\n  padding: 10px 14px;\n  margin: 12px 0;\n  border-radius: 4px;\n  color: var(--color-text-light);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n@media (max-width: 900px) {\n  .help-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .help-sidebar {\n    position: relative;\n    top: 0;\n    max-height: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
